import { Link, useLocation } from '@tanstack/react-router';
import { PAGE_IDS } from '@/constants/pages';
import { sparkRoute } from '@/customizations/navigationItems';
import { useSamePageNavigation } from '@/hooks/useSamePageNavigation';
import { tw } from '@/lib/tailwind';

const SPARK_PATH = `/dashboard/${PAGE_IDS.Spark}` as const;

export default function SparkNavigationItem() {
  const { isCurrentPage } = useSamePageNavigation();
  const routerLocation = useLocation();
  const isActivePage = routerLocation.pathname === SPARK_PATH;

  return (
    <Link
      to={SPARK_PATH}
      search={isCurrentPage(SPARK_PATH, {}) ? { reload: new Date().getTime() } : {}}
      className={tw(
        `hover:border-background-400 hover:bg-background-100 transition-colors`,
        `relative z-20 flex items-center gap-0.5`,
        `border-b border-solid px-2.5 py-2`,
        `${isActivePage ? 'border-background-400' : 'border-transparent'}`,
      )}
    >
      {sparkRoute.label}
    </Link>
  );
}
